import { LogLevel } from '@grafana/faro-web-sdk';
import { WeightMetric } from '../../../model/prefixed-unit/weight.metric';
import { LoggingService } from '../../logging.service';

export function displayUnitExponentToDisplayUnit(
  loggingService: LoggingService,
  displayUnitExponent?: number
): WeightMetric {
  switch (displayUnitExponent) {
    case 0:
      return WeightMetric.Gram;
    case 3:
      return WeightMetric.KiloGram;
    case 6:
      return WeightMetric.Tonne;
    case 9:
      return WeightMetric.KiloTonne;
    case 12:
      return WeightMetric.MegaTonne;
    case 15:
      return WeightMetric.GigaTonne;
    default:
      loggingService.logMessage(
        `Board has unsupported displayUnitExponent: ${displayUnitExponent}`,
        undefined,
        LogLevel.WARN
      );
      return WeightMetric.Tonne;
  }
}
